import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../../Helper/ToastMessage";

// Get Table Data
export const WaterPressureTableDataAPI = createAsyncThunk("WaterPressureTableData", async ({ data }) => {
    const {
        ReadingDate,
        M_WardID,
        M_WS_JunctionID,
        M_UserID,
        Flag,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID,
        // handleWaterPressureExport
        // handleGetPDFUrl
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url

    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterPressure_Select?ReadingDate=${ReadingDate ? ReadingDate : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterPressure_Select?ReadingDate=${ReadingDate ? ReadingDate : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                // { Flag == 'Report' && handleGetPDFUrl(result.url) }
                if (DashProjectTypeId == '6' && RoleID != '16') {
                    // handleWaterPressureExport && handleWaterPressureExport()
                    return result.data.table
                }
                else {
                    return result.data
                }

            } else {
                return result
            }
        })
})

const WaterPressureTableDataSlice = createSlice({
    name: "WaterPressureTableData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterPressureTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterPressureTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterPressureTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterPressureTableDataReducer = WaterPressureTableDataSlice.reducer


export const WaterPressureExportTableDataAPI = createAsyncThunk("WaterPressureExportTableData", async ({ data }) => {
    const {
        ReadingDate,
        M_WardID,
        M_WS_JunctionID,
        M_UserID,
        token,
        From,
        To,
        DashProjectTypeId,
        RoleID,
        Flag,
        // handleGetPDFUrl
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_Distri_WaterPressure_Select?ReadingDate=${ReadingDate ? ReadingDate : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_Distri_WS_LocationID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    } else {
        url = `${BaseUrl}/APKDashboard/Get_WEB_WS_T_WS_WaterPressure_Select?ReadingDate=${ReadingDate ? ReadingDate : '0'}&M_WardID=${M_WardID ? M_WardID : '0'}&M_WS_JunctionID=${M_WS_JunctionID ? M_WS_JunctionID : '0'}&M_UserID=${M_UserID}&Flag=${Flag}&From=${From}&To=${To}`
    }
    return fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            // if (result.code >= 200 && result.code <= 300 && result.data_Report) {
            //     // { Flag == 'Report' && handleGetPDFUrl(result.url) }
            //     return result.data_Report
            // } else {
            //     return result
            // }
            if (DashProjectTypeId == '6' && RoleID != '16') {
                if (result.code >= 200 && result.code <= 300 && result.data) {
                    // { Flag == 'Report' && handleGetPDFUrl(result.url) }
                    return result.data
                } else {
                    return result
                }
            }
            if (result.code >= 200 && result.code <= 300 && result.data_Report) {
                // { Flag == 'Report' && handleGetPDFUrl(result.url) }
                return result.data_Report
            } else {
                return result
            }
        })
})

const WaterPressureExportTableDataSlice = createSlice({
    name: "WaterPressureTableData",
    initialState: {
        isExportLoading: false,
        ExportTableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterPressureExportTableDataAPI.pending, (state, action) => {
            state.isExportLoading = true;
        });
        builder.addCase(WaterPressureExportTableDataAPI.fulfilled, (state, action) => {
            state.isExportLoading = false;
            state.ExportTableData = action.payload;
        });
        builder.addCase(WaterPressureExportTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isExportLoading = false;
            state.isError = true;
            state.ExportTableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const WaterPressureExportTableDataReducer = WaterPressureExportTableDataSlice.reducer


export const WaterPressurePostDataAPI = createAsyncThunk("PumpingStationPostData", async ({ data }) => {
    const {
        T_WS_WaterPressureID,
        T_Distri_WaterPressureID,
        Pressure,
        M_UserID,
        token,
        Flag,
        handleIsPost,
        handleClearField,
        handleOnCloseClick,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterPressureID", T_Distri_WaterPressureID);
    } else {
        formdata.append("T_WS_WaterPressureID", T_WS_WaterPressureID);
    }
    formdata.append("Pressure", Pressure);
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'PATCH',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };

    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_Distri_WaterPressure_Update`
    } else {
        url = `${BaseUrl}/APKDashboard/Post_WEB_WS_T_WS_WaterPressure_Update`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                handleIsPost()
                // handleClearField()
                handleOnCloseClick()
                toastSuccesss(result.message)
                return result.data
            } else {
                toastErrorr(result.message)
            }
            return result
        })
})

const WaterPressurePostDataSlice = createSlice({
    name: "WaterPressurePostData",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterPressurePostDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(WaterPressurePostDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(WaterPressurePostDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterPressurePostDataReducer = WaterPressurePostDataSlice.reducer

// -----------------Delete API ---------------

export const WaterPressureDeleteAPI = createAsyncThunk("WaterPressureDelete", async ({ data }) => {
    const {
        T_WS_WaterPressureID,
        T_Distri_WaterPressureID,
        M_UserID,
        token,
        handleIsPost,
        DashProjectTypeId,
        RoleID
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var formdata = new FormData();
    // formdata.append("T_WS_WaterPressureID", "20");
    // 

    if (DashProjectTypeId == '6' && RoleID != '16') {
        formdata.append("T_Distri_WaterPressureID", T_Distri_WaterPressureID);
    } else {
        formdata.append("T_WS_WaterPressureID", T_WS_WaterPressureID);
    }
    formdata.append("M_UserID", M_UserID);

    var requestOptions = {
        method: 'DELETE',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
    };


    let url
    if (DashProjectTypeId == '6' && RoleID != '16') {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_Distri_WaterPressure_Delete`
    } else {
        url = `${BaseUrl}/APKDashboard/WEB_WS_T_WS_WaterPressure_Delete`
    }

    fetch(url, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.status) {
                handleIsPost()
                toastSuccesss(result.message)
            } else {
                toastErrorr(result.message)

            }
            return result

        })
})

const WaterPressureDeleteSlice = createSlice({
    name: "WaterPressureDelete",
    initialState: {
        isDeleteLoading: false,
        SectorData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(WaterPressureDeleteAPI.pending, (state, action) => {
            state.isDeleteLoading = true;
        });
        builder.addCase(WaterPressureDeleteAPI.fulfilled, (state, action) => {
            state.isDeleteLoading = false;
            state.SectorData = action.payload;

        });
        builder.addCase(WaterPressureDeleteAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isDeleteLoading = false;
            state.isError = true;
            state.SectorData = null;
            // toastErrorr('Something went wrong')
        });
    },
})

export const WaterPressureDeleteReducer = WaterPressureDeleteSlice.reducer